import { Button } from "@/components/shared/buttons/Button";
import { ErrorOutline } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";

interface IProps {
    /**
     * Callback to close the dialog
     */
    onClose: () => void;
}

/**
 * Component that is displayed when an error occurs while saving a clause checklist
 */
export const ClauseChecklistMutationError = ({ onClose }: IProps) => {
    return (
        <>
            <ErrorOutline color={"error"} sx={{ width: 48, height: 48 }} />
            <Stack alignItems={"center"}>
                <Typography variant="h6" fontWeight={600}>
                    An Error Occurred
                </Typography>

                <Typography variant={"body2"} color={"textSecondary"}>
                    The clause checklist couldn't be saved.
                </Typography>
            </Stack>

            <Box flexGrow={1} />

            <Box>
                <Button
                    type="button"
                    variant="outlined"
                    sx={{ borderRadius: 2, py: 1, minWidth: 180 }}
                    fullWidth
                    onClick={onClose}
                >
                    Close
                </Button>
            </Box>
        </>
    );
};
